import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import itemId from 'owa-service/lib/factory/itemId';
import { getGuid } from 'owa-guid';

/**
 * Applies local lie properties to series calendar events
 * The resulting calendar events will all have InstanceKeys which equal the ClientSeriesId.
 * @param items series calendar events
 */
export function applyLocalLiePropertiesToSeriesEvents(items: CalendarEvent[]) {
    let clientSeriesId = getGuid();
    items.forEach(item => {
        // We can't have the same ItemId for instances of a recurring meeting as it's the primary key for the cache,
        // but the InstanceKey will be set to clientSeriesId for isCalendarEventLocalLie check for local lie.
        const temporaryItemId = getGuid();
        applyLocalLiePropertiesToEventInternal(item, clientSeriesId, temporaryItemId);
        item.IsRecurring = true;
        item.InstanceKey = item.InstanceKey ? item.InstanceKey : clientSeriesId; // All instances given the same client series id here
    });
}

/**
 * Applies local lie properties to a non-recurring calendar event.
 * The resulting calendar event will have an ItemId which is equal to the ClientSeriesId.
 * @param item non-recurring calendar event
 */
export function applyLocalLiePropertiesToSingleEvent(item: CalendarEvent) {
    const clientSeriesId = getGuid();
    // We want to make the ItemId match the ClientSeriesId for non-recurring meetings
    applyLocalLiePropertiesToEventInternal(item, clientSeriesId, clientSeriesId);
}

/**
 * @param item calendar event to be updated
 * @param clientSeriesId client series id used to identify all events in a series
 * @param temporaryItemId temporary item id used to uniquely identify each event
 */
function applyLocalLiePropertiesToEventInternal(
    item: CalendarEvent,
    clientSeriesId: string,
    temporaryItemId: string
) {
    item.ItemId = {
        ...itemId({ Id: temporaryItemId }),
        mailboxInfo: item.ParentFolderId.mailboxInfo,
    };
    if (!item.ClientSeriesId) {
        // If we have the ClientSeriesId already set, then it means this is the retry scenario
        // In the retry scenario, we don't override the clientSeriesId since we want the server to be
        // able to de-duplicate in case the failed request created the item for some reason
        item.ClientSeriesId = clientSeriesId;
    }

    item.EffectiveRights = {
        Read: true,
        Modify: true,
        Delete: true,
        ViewPrivateItems: true,
    };
    item.IsOrganizer = true;
}
